export const VERIFICATION_CODE_DIGITS = 6
export const INITIAL_VERIFICATION_CODE = Array(VERIFICATION_CODE_DIGITS).fill('')
